export default __webpack_public_path__ + "images/blocworx-logo-2022.svg";